import { Descriptions, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { chineseDrugLink, plantDetailLink } from '../hooks/TableLink';

import useFetch from '../hooks/fetcher';
import { useParams } from 'react-router-dom';

const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';

const { Title } = Typography;
const { Item } = Descriptions;

const columns = [
    { title: 'Accepted Botanical Name', key: 'botanical_name', dataIndex: 'botanical_name', render: plantDetailLink },
    { title: 'Transliteration', key: 'pinyin', dataIndex: 'pinyin', render: chineseDrugLink },
    {
        title: 'Chinese Pharmaceutical Name',
        key: 'chinese_pharmaceutical_name',
        dataIndex: 'chinese_pharmaceutical_name',
        render: chineseDrugLink,
    },
    { title: 'Pharmaceutical Latin Name', key: 'pharmaceutical_latin_name', dataIndex: 'pharmaceutical_latin_name' },
    { title: 'Chinese Pharmacopoeia', key: 'chp_2015', dataIndex: 'chp_2015' },
    { title: 'Used Part', key: 'used_part', dataIndex: 'used_part' },
];

type TcmInfoType = {
    chinese_id: string;
    botanical_id: string;
    botanical_name: string;
    pinyin: string;
    chinese_pharmaceutical_name: string;
    pharmaceutical_latin_name: string;
    chp_2015: string;
    used_part: string;
};

// response model from backend
type PlantDetailType = {
    unique_botanical_name: {
        botanical_id: string;
        botanical_name: string;
        mpns_url: string;
        ncbi_url: string;
        mpns_id: string;
        taxid: string;
    };
    synonyms: { synonyms: string }[];
    common_name: { common_name: string }[];
    tcm_info: TcmInfoType[];
    chinese_drug: TcmInfoType[];
};

const PagePlantDetail: React.FC = () => {
    const [result, setResult] = useState<PlantDetailType>();
    const { name: searchId } = useParams<any>();
    const { get } = useFetch(API_SERVICE_BASE_URL);
    useEffect(() => {
        get('/api/plant_detail.php', { botanical_id: searchId }).then((r) => setResult(r));
    }, []);
    return (
        <div>
            <Title level={3}>Botanical source: {result?.unique_botanical_name.botanical_name}</Title>
            <Title level={4}>Source Details</Title>
            <Descriptions bordered colon column={1} size="middle" style={{ marginBottom: '3vh' }}>
                <Item label="Botanical Synonyms">{result?.synonyms.map((e) => e.synonyms).join(', ')}</Item>
                <Item label="Plant Common Names">{result?.common_name.map((e) => e.common_name).join(', ')}</Item>
                <Item label="NCBI Taxonomy ID">
                    <a href={result?.unique_botanical_name.ncbi_url} target="_blank" rel="noopener noreferrer">
                        {result?.unique_botanical_name.taxid}
                    </a>
                </Item>
                <Item label="Medicinal Plant Names Services (MPNS) plantID">
                    <a href={result?.unique_botanical_name.mpns_url} target="_blank" rel="noopener noreferrer">
                        {result?.unique_botanical_name.mpns_id}
                    </a>
                </Item>
            </Descriptions>

            <Title level={4}>Related TCM information from the current source</Title>
            <Table dataSource={result?.tcm_info} columns={columns} rowKey={(record): string => record.botanical_id} />

            <Title level={4}>Related TCM information from other botanical sources</Title>
            <Table
                dataSource={result?.chinese_drug}
                columns={columns}
                rowKey={(record): string => record.botanical_id}
            />
        </div>
    );
};

export default PagePlantDetail;
